module.exports = __webpack_public_path__ + "img/quick-label-print-fr.bdb64977.jpg";